import { render, staticRenderFns } from "./filial-settings-popover.vue?vue&type=template&id=e4ae67fc&scoped=true&"
import script from "./filial-settings-popover.vue?vue&type=script&lang=js&"
export * from "./filial-settings-popover.vue?vue&type=script&lang=js&"
import style0 from "./filial-settings-popover.vue?vue&type=style&index=0&id=e4ae67fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ae67fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ae67fc')) {
      api.createRecord('e4ae67fc', component.options)
    } else {
      api.reload('e4ae67fc', component.options)
    }
    module.hot.accept("./filial-settings-popover.vue?vue&type=template&id=e4ae67fc&scoped=true&", function () {
      api.rerender('e4ae67fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/data-table/filial-settings-popover.vue"
export default component.exports